import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {
  getCountertopArea,
} from "../../helpers/sqftCalculations";
import SqftSummaryRadii from "./summary/SqftSummaryRadii";
import SqftSummaryAngles from "./summary/SqftSummaryAngles";
import SqftSummaryBumpouts from "./summary/SqftSummaryBumpouts";
import SqftSummaryFeatureColors from "./summary/SqftSummaryFeatureColors";
import workspace from "../canvas/core/workspace";
import SqftSummaryEdges from "./summary/SqftSummaryEdges";
import SqftSummaryBacksplashes from "./summary/SqftSummaryBacksplashes";
import SqftSummaryWall from "./summary/SqftSummaryWall";

const SqftNavSummary = (props) => {
  const {updateCalculations} = props;
  const {menuOpened, activeButton} = props;
  const [counterTopArea, setCounterTopArea] = useState({});
  const [bumpouts, setBumpouts] = useState([]);
  const [edges, setEdges] = useState([]);
  const [backsplashes, setBacksplashes] = useState([]);
  const [walls, setWalls] = useState([]);

  useEffect(() => {
    if (activeButton === "summary") {
      setEdges(workspace.getShapeType('edge'));
      setBacksplashes(workspace.getShapeType('backsplash'));
      setWalls(workspace.getShapeType('wall'));
      setBumpouts(workspace.getBumpouts())
      setCounterTopArea(getCountertopArea())
    }
  }, [updateCalculations, activeButton]);

  return (
    <div className={"summary-bar content content--right" + (menuOpened && activeButton && activeButton === "summary" ? " expanded" : "")} data-side="summary">
      <div className="content-inner">
        <div className="summary-main-title">
          <FormattedMessage id={"sqft.navigation.summary.title"}/>
        </div>
        <div className="summary-list">
          <div className="summary-list-countertops">
            <div className="summary-list__item summary summary--red">
              <div className="summary-title" data-text="sqft.navigation.summary.countertopSize">
                <FormattedMessage id={"sqft.navigation.summary.countertopSize"}/>
              </div>
              <div className="summary-info">
                <div className="summary-info__left shapes-count">
                  <span className="shapes-count__text" data-text="sqft.navigation.summary.shapes">
                    <FormattedMessage id={"sqft.navigation.summary.shapes"}/>
                  </span>
                  <span className="shapes-count__num">
                    {counterTopArea.shapeLength}
                  </span>
                </div>
                <div className="summary-info__right shapes-total">
                  <span className="shapes-total__text" data-text="sqft.navigation.summary.shapesTotal">
                    <FormattedMessage id={"sqft.navigation.summary.shapesTotal"}/></span>
                  <span className="shapes-total__num">
                    {counterTopArea.totalAreaToMeasureUnit}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="summary-list-radius">
            <SqftSummaryRadii/>
          </div>
          <div className="summary-list-angles">
            <SqftSummaryAngles/>
          </div>
          <div className="summary-list-bumpouts">
            {
              bumpouts.length > 0 ? <SqftSummaryBumpouts bumpouts={bumpouts}/> : ""
            }
          </div>
          <div className="summary-list-edges">
            {
              edges.length > 0 ? <SqftSummaryEdges edges={edges}/> : ""
            }
          </div>
          <div className="summary-list-backsplashes">
            {
              backsplashes.length > 0 ? <SqftSummaryBacksplashes backsplashes={backsplashes}/> : ""
            }
          </div>
          <div className="summary-list-walls">
            {
              walls.length > 0 ? <SqftSummaryWall walls={walls}/> : ""
            }
          </div>
          <div className="summary-list-features">
            <SqftSummaryFeatureColors />
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavSummary);
